const size = (factor) => 8 * factor;
/**
 * Spacer Size
 */
export var SpacerSize;
(function (SpacerSize) {
    SpacerSize[SpacerSize["NONE"] = 0] = "NONE";
    SpacerSize[SpacerSize["SMALLER"] = size(0.5)] = "SMALLER";
    SpacerSize[SpacerSize["SMALL"] = size(1)] = "SMALL";
    SpacerSize[SpacerSize["MEDIUM"] = size(2)] = "MEDIUM";
    SpacerSize[SpacerSize["LARGE"] = size(3)] = "LARGE";
    SpacerSize[SpacerSize["HUGE"] = size(4)] = "HUGE";
})(SpacerSize || (SpacerSize = {}));
//# sourceMappingURL=SpacerEnum.js.map